import { isExecutive, isOrganizationAdmin, isReportingManager, type Role } from "@packages/core/session/roles.ts";

export const ORGANIZATION_ENGAGEMENT_ACCESS: readonly Role[] = [isReportingManager, isExecutive];

export const ORGANIZATION_FEEDBACK_INBOX_ACCESS: readonly Role[] = [isExecutive, isOrganizationAdmin];

export const ORGANIZATION_GOALS_ACCESS: readonly Role[] = [isReportingManager, isExecutive];
